@if((this.userId == 0 || this.userId == Number(this.authService.currentUserIds) || this.userId == null) &&
!isModeEdition){
<!-- class mobile solo para verificar en el navegador el cambio -->
<div id="clientMobile">
  <div class="title">
    <h3>Cliente</h3>
    <label class="checkboxWrapper" for="conRFC">
      <input
        type="checkbox"
        id="conRFC"
        [checked]="isClientWithRFC()"
        [disabled]="forceReadOnly"
        (change)="onCheckboxChange($event)"
      />
      <span class="checkmark"></span>
      <span class="description">Con RFC</span>
    </label>
    <div class="acciones">
      @if(!forceReadOnly && isClientWithRFC() && formHasRFC){
      <a tp="Seleccionar otro cliente" class="refresh" (click)="openModalSelectClient()">Seleccionar otro cliente</a>
      }
      @if(isEditable){
      <a class="edit" tp="Editar cliente" (click)="openEditClient()">Editar</a>
      }
    </div>
  </div>
  <form [formGroup]="formCustomer">
    @if(!isClientWithRFC()){
    <!-- Form para clientes sin RFC - Información básica para cotización ágil -->
    <div>
      <div class="wrapper">
        <div class="controlWrapper">
          <label for="">Tipo de persona <span class="required">*</span></label>
          <div class="customSelect">
            <select type="text" formControlName="personType" (ngModelChange)="validatorChange()"
              (keypress)="allowAlphabeticCharacter($event)" tabindex="9">
              <option [value]="'NATURAL_PERSON'" selected>
                Persona física
              </option>
              <option [value]="'LEGAL_PERSON'" selected>
                Persona moral
              </option>
            </select>
          </div>
          <div *ngIf="
                formCustomer.get('personType')?.hasError('required') &&
                formCustomer.get('personType')?.touched
              ">
            El campo es requerido.
          </div>
        </div>
      </div>
      <div class="wrapperG4">
        <div class="controlWrapper" *ngIf="
              this.formCustomer.controls['personType'].value == 'NATURAL_PERSON'
            ">
          <label for="paternalSurname">Apellido paterno <span class="required">*</span></label>
          <input name="" type="text" id="paternalSurname" formControlName="lastName" tabindex="10"
            (keydown)="allowOnlyLettersAndNumbers($event)" (input)="cleanNaturalPersonInput($event)"
            (paste)="onPasteNaturalPerson($event)" />
        </div>
        <div class="controlWrapper" *ngIf="
              this.formCustomer.controls['personType'].value == 'NATURAL_PERSON'
            ">
          <label for="maternalSurname">Apellido materno</label>
          <input name="" type="text" id="maternalSurname" formControlName="mothersLastName"
            tabindex="11" (keydown)="allowOnlyLettersAndNumbers($event)" (input)="cleanNaturalPersonInput($event)"
            (paste)="onPasteNaturalPerson($event)" />
        </div>
        <div class="controlWrapper">
          <label for="customerName">Nombre <span class="required">*</span></label>
          <input *ngIf="
                this.formCustomer.controls['personType'].value == 'NATURAL_PERSON';
                else JuridicalPerson
              " name="customerName" type="text" id="customerName" formControlName="firstName"
            tabindex="12"
            (keydown)="this.formCustomer.controls['personType'].value == 'NATURAL_PERSON' ? allowOnlyLettersAndNumbers($event) : allowAlphabeticCharacter($event)"
            (input)="this.formCustomer.controls['personType'].value == 'NATURAL_PERSON' ? cleanNaturalPersonInput($event) : null"
            (paste)="this.formCustomer.controls['personType'].value == 'NATURAL_PERSON' ? onPasteNaturalPerson($event) : null" />
          <ng-template #JuridicalPerson>
            <input name="customerName" type="text" id="customerName" formControlName="firstName"
              tabindex="10"
              (keydown)="this.formCustomer.controls['personType'].value == 'NATURAL_PERSON' ? allowOnlyLettersAndNumbers($event) : allowAlphabeticCharacter($event)"
              (input)="this.formCustomer.controls['personType'].value == 'NATURAL_PERSON' ? cleanNaturalPersonInput($event) : null"
              (paste)="this.formCustomer.controls['personType'].value == 'NATURAL_PERSON' ? onPasteNaturalPerson($event) : null" />
          </ng-template>
        </div>
        <div class="controlWrapper" *ngIf="
              this.formCustomer.controls['personType'].value == 'NATURAL_PERSON'
            ">
          <label for="secondName">Segundo nombre</label>
          <input name="" type="text" id="secondName" formControlName="secondName" tabindex="13"
            (keydown)="allowOnlyLettersAndNumbers($event)" (input)="cleanNaturalPersonInput($event)"
            (paste)="onPasteNaturalPerson($event)" />
        </div>
      </div>
      @if (featureLoyaltyFeriaQuotation) {
      <div class="packageProgramsRow">
        <div class="controlWrapper">
          <label>Cliente de feria</label>
          <span class="value">{{ customerFeriaReadonlyYesNo() }}</span>
        </div>
      </div>
      }
    </div>
    } @else {
    <!-- Form para clientes con RFC - Información completa del cliente para cotizar -->
    <div>
      <div class="wrapperG4 withRfc">
        <!-- Mostrar si el cliente está seleccionado -->
        @if(personType){
        <div class="controlWrapper">
          <label>Tipo de persona</label>
          <span class="value">{{ clientsService.getPersonType(personType) }}</span>
        </div>
        }
        @if(rfc){
        <div class="controlWrapper">
          <label>RFC</label>
          <span class="value">{{ rfc }}</span>
        </div>
        }
        @if(!isLegalPerson()) {
        @if(lastName){
        <div class="controlWrapper">
          <label>Apellido paterno</label>
          <span class="value">{{ lastName }}</span>
        </div>
        }
        @if(mothersLastName){
        <div class="controlWrapper">
          <label>Apellido materno</label>
          <span class="value">{{ mothersLastName }}</span>
        </div>
        }
        }
        @if(name){
        <div class="controlWrapper" [ngClass]="{ moral: isLegalPerson() }">
          <label>Nombre</label>
          <span class="value">{{ name }}</span>
        </div>
        }
      </div>
      <!-- Mostrar sin no hay ningun cliente seleccionado -->
      @if(!forceReadOnly && !formHasRFC){
      <div class="actions withRfc">
        <button class="tertiary" (click)="openModalSelectClient()" tabindex="9">Seleccionar cliente</button>
      </div>
      }
    </div>
    }

    @if (featureLoyaltyFeriaQuotation) {
    <div class="loyaltyFeriaFlags" aria-label="Cliente Feria">
      <label class="checkboxWrapper" for="stdFeriaMob">
        <input
          type="checkbox"
          id="stdFeriaMob"
          [ngModel]="formCustomer.get('feriaCustomer')?.value"
          (ngModelChange)="onFeriaCustomerToggle($event)"
        />
        <span class="checkmark"></span>
        <span class="description">Cliente de feria</span>
      </label>
    </div>
    }

  </form>
</div>
} @if((this.userId != Number(this.authService.currentUserIds) && this.userId > 0) || isModeEdition){
<!-- Versión sólo lectura -->
<div id="clientMobile" class="readOnly">
  <h3>Cliente</h3>
  <div class="wrapper">
    <div>
      <label>Tipo de persona</label>
      <span class="value">{{ clientsService.getPersonType(formCustomer.controls['personType'].value) }}</span>
    </div>

    @if(rfc){
    <div>
      <label>RFC</label>
      <span class="value">{{ rfc }}</span>
    </div>
    }

    @if(lastName){
    <div>
      <label>Apellido paterno</label>
      <span class="value">{{ lastName }}</span>
    </div>
    }

    <div *ngIf="this.formCustomer.controls['personType'].value == 'NATURAL_PERSON'">
      <label>Apellido materno</label>
      <span class="value">{{ mothersLastName }}</span>
    </div>

    @if(name){
    <div>
      <label>Nombre</label>
      <span class="value">{{ name }}</span>
    </div>
    }

    @if(secondName){
    <div *ngIf="this.formCustomer.controls['personType'].value == 'NATURAL_PERSON'">
      <label>Segundo nombre</label>
      <span class="value">{{ secondName }}</span>
    </div>
    }
    @if (featureLoyaltyFeriaQuotation) {
    <div class="packageProgramsRow">
      <div>
        <label>Cliente de feria</label>
        <span class="value">{{ customerFeriaReadonlyYesNo() }}</span>
      </div>
    </div>
    }
  </div>
</div>
}

<ng-template #modalSelectClient>
  <app-client-form-modal-mobile (savedClient)="saveAndUpdateClientForm($event)" [client]="null"
    (cancelModalE)="cancelModal($event)" />
</ng-template>
<ng-template #modalNewClient>
  <app-client-form-modal-mobile (savedClient)="saveAndUpdateClientForm($event)" [client]="selectedClient()"
    (cancelModalE)="cancelModal($event)" />
</ng-template>
<ng-template #personTypeChangeConfirmation>
  <confirmation-dialog (closed)="handlePersonTypeChangeConfirmation($event)"></confirmation-dialog>
</ng-template>
